<template>
  <el-dialog
    :visible.sync="visible"
    width="860px"
    :before-close="handleClose"
    custom-class="downstream-aggregate-dialog"
  >
    <template slot="title">
      <div class="dialog-title">
        <i class="el-icon-s-data"></i>
        <span>结算单详情</span>
      </div>
    </template>

    <div class="report-info">
      <div class="info-item">
        <span class="info-label">报表名</span>
        <span class="info-value">{{ row.fileName || '--' }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">结算日期</span>
        <span class="info-value">{{ formatDate(row.settlementDate) }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">结算渠道</span>
        <span class="info-value">{{ row.channelAccountName || '--' }}</span>
      </div>
    </div>

    <el-table v-loading="loading" :data="records" border stripe>
      <el-table-column prop="downstreamAccountId" label="下游用户ID" min-width="180" />
      <el-table-column prop="downstreamAccountName" label="下游用户昵称" min-width="180">
        <template slot-scope="{ row: item }">{{ item.downstreamAccountName || '--' }}</template>
      </el-table-column>
      <el-table-column prop="orderCount" label="订单数" min-width="100" align="right" />
      <el-table-column prop="commissionAmount" label="佣金金额" min-width="140" align="right">
        <template slot-scope="{ row: item }">¥{{ formatMoney(item.commissionAmount) }}</template>
      </el-table-column>
    </el-table>

    <div class="pagination-wrap">
      <el-pagination
        v-if="pageInfo.total > 0"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageInfo.size"
        :current-page="pageInfo.current"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </div>

    <template slot="footer">
      <el-button type="primary" icon="el-icon-download" :loading="exporting" @click="handleExport">
        导出
      </el-button>
      <el-button @click="handleClose">关 闭</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { saveAs } from 'file-saver'
const dayjs = require('dayjs')

export default {
  name: 'DownstreamAggregateDialog',
  props: {
    value: { type: Boolean, default: false },
    row: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      loading: false,
      exporting: false,
      records: [],
      pageInfo: {
        current: 1,
        size: 20,
        total: 0
      }
    }
  },
  computed: {
    visible: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) {
          this.pageInfo.current = 1
          this.loadData()
        }
      }
    }
  },
  methods: {
    loadData() {
      if (!this.row.id) return
      this.loading = true
      this.$http('post', 'mall/bdM2sSettlementReport/downstreamAggregate/page', {
        reportId: this.row.id,
        pageIndex: this.pageInfo.current,
        pageSize: this.pageInfo.size
      }).then(res => {
        const data = res || {}
        this.records = data.records || []
        this.pageInfo.total = Number(data.total || 0)
      }).catch(() => {}).finally(() => {
        this.loading = false
      })
    },
    handleCurrentChange(page) {
      this.pageInfo.current = page
      this.loadData()
    },
    handleSizeChange(size) {
      this.pageInfo.size = size
      this.pageInfo.current = 1
      this.loadData()
    },
    handleExport() {
      this.exporting = true
      this.$http('get', 'mall/bdM2sSettlementReport/downstreamAggregate/export', {
        reportId: this.row.id
      }, true).then(blob => {
        const fileName = `${this.row.fileName || '结算单'}-下游聚合.xlsx`
        saveAs(blob, fileName)
      }).catch(() => {}).finally(() => {
        this.exporting = false
      })
    },
    formatDate(value) {
      return value ? dayjs(value).format('YYYY-MM-DD') : '--'
    },
    formatMoney(value) {
      return Number(value || 0).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    handleClose() {
      this.$emit('input', false)
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.dialog-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  font-weight: 500;
}
.dialog-title i {
  color: #1990ff;
  font-size: 20px;
}
.report-info {
  display: flex;
  gap: 24px;
  padding: 14px 18px;
  margin-bottom: 16px;
  border: 1px solid #e8ecf2;
  border-radius: 6px;
  background: #fafbfc;
}
.info-item {
  flex: 1;
  min-width: 0;
}
.info-label {
  display: block;
  margin-bottom: 5px;
  color: #999;
  font-size: 12px;
}
.info-value {
  display: block;
  overflow: hidden;
  color: #333;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pagination-wrap {
  margin-top: 16px;
  text-align: right;
}
</style>
